module.exports = __webpack_public_path__ + "img/active-bookmark.b64a0e7d.svg";